import React from 'react'
import {Stats} from '../../shared/Stats'
import {RestrictMobileScreenDisplay} from '@therms/react-modules'

function StatsIndexScreen() {
  return (
    <RestrictMobileScreenDisplay text="Stats are not designed for mobile or small screens">
      <Stats />
    </RestrictMobileScreenDisplay>
  )
}

export {StatsIndexScreen}
